<script setup lang="ts">

import { apps, useContext, useDialogs, useOrderViewContext } from "@hantera/portal-app";
import { Toolbar, type ToolbarDropdownOption, type ToolbarItem } from "@hantera/design-system";
import { computed } from "vue";
import Payment from "./Payment.vue";
import LinkExistingPaymentDialog from "./LinkExistingPaymentDialog.vue";
import useApps from "@/composition/use-apps";

const orderViewContext = useOrderViewContext();
const appsContext = useApps();
const context = useContext();
const dialogs = useDialogs();

function openLinkExistingPaymentDialog() {
  dialogs.openModal('Link existing payment', LinkExistingPaymentDialog, true, {
    orderViewContext
  });
}

const toolbarItems = computed<ToolbarItem[]>(() => {
  const newPaymentOptions: ToolbarDropdownOption[] = [{
    id: 'link-existing-payment',
    label: 'Link existing payment',
    icon: 'link',
    onClick: openLinkExistingPaymentDialog
  }]

  for (const provider of appsContext.getServices(apps.standardServices.orderView.paymentActionsProvider)) {
    const options = provider.buildNewPaymentOptions(context, orderViewContext)
    if (!Array.isArray(options)) {
      continue
    }

    for (const option of options) {
      newPaymentOptions.push({
        id: option.id,
        label: typeof option.label === 'string' ? option.label : option.label.value,
        icon: option.icon,
        disabled: option.disabled,
        onClick: option.onClick
      })
    }
  }

  return [{
    type: 'dropdown',
    id: 'add-payment',
    label: 'Add',
    icon: 'plus',
    buttonStyle: 'primary',
    options: newPaymentOptions
  }]
})

</script>

<template>

  <Toolbar :items="toolbarItems" />

  <div class="payments">
    <Payment
      v-for="payment in orderViewContext.state.payments"
      :key="payment.paymentId"
      :payment="payment"
    />
  </div>

</template>

<style scoped>
.payments {
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: min-content;
  gap: 10px;
  margin: 10px;
}
</style>
